import { DataTable, Dialog, FormLabel, Heading, Loader, Select } from "@/components";
import { Button, Input } from "@/components/ui";
import { Search } from "lucide-react";
import useVendorMgmt from "./useVendorMgmt";

const VendorMgmt = () => {
  const {
    isMobile,
    globalFilter,
    setGlobalFilter,
    onAdd,
    vendorList,
    isVendorLoading,
    columns,
    onRowClick,
    openDeleteDialog,
    setOpenDeleteDialog,
    isDeletePending,
    onDeleteConfirm,
    deletedRow,
    setPageNumber,
    setPageSize,
    pageNumber,
    pageSize,
    sorting,
    setSorting,
    isMasterDataRoute,
    communityList,
    isCommunityLoading,
    communityId,
    onCommunityChange,
    communityKey,
  } = useVendorMgmt();

  return (
    <div className="p-4 md:p-6">
      {/* Header & Search */}
      <div className="flex flex-col xl:flex-row gap-2 xl:items-center xl:justify-between mb-6">
        <div className="flex flex-row items-center justify-between">
          <Heading title="Vendor Management" />
          {isMobile && (
            <Button onClick={onAdd} className="px-2">
              + Add
            </Button>
          )}
        </div>
        <div className="flex flex-col md:flex-row md:items-center gap-4 mt-4 md:mt-auto">
          {isMasterDataRoute && (
            <div className="relative w-full sm:w-72 sm:min-w-72 sm:max-w-72 shrink-0">
              <FormLabel>Select Community</FormLabel>
              <Select
                key={communityKey}
                placeholder={""}
                searchPlaceholder={""}
                noDataPlaceholder={"Community No Found"}
                options={communityList?.data?.map((data: any) => ({
                  value: data?.communityId?.toString(),
                  label: data?.name,
                }))}
                value={communityId?.toString()}
                onChange={onCommunityChange}
                className="h-[36px] w-full"
                disabled={isCommunityLoading}
              />
            </div>
          )}
          <Input
            type="text"
            placeholder="Search"
            value={globalFilter ?? ""}
            onChange={(e) => setGlobalFilter(e.target.value)}
            className="w-full sm:w-72 bg-white h-[40px]"
            startIcon={<Search className="w-4 h-4" />}
          />
          {!isMobile && <Button onClick={onAdd}>+ Add</Button>}
        </div>
      </div>

      {/* Responsive Table */}
      {isVendorLoading ? (
        <Loader />
      ) : (
        <>
          <DataTable
            columns={columns}
            data={[...(vendorList?.data || [])]
              .sort((a, b) => {
                return a.communityId - b.communityId;
              })
              .reverse()}
            setGlobalFilter={setGlobalFilter}
            globalFilter={globalFilter}
            onRowClick={onRowClick}
            setPageNumber={setPageNumber}
            setPageSize={setPageSize}
            pageNumber={pageNumber}
            pageSize={pageSize}
            totalPages={Math.ceil(vendorList?.total / pageSize)}
            totalRecords={vendorList?.total}
            serverSidePagination={true}
            sorting={sorting}
            onSortingChange={setSorting}
          />
          <Dialog
            open={openDeleteDialog}
            setOpen={setOpenDeleteDialog}
            title={
              <div className="text-2xl font-bold text-primary">
                {"Confirmation"}
                <div className="h-1 w-[30%] bg-primary rounded-full" />
              </div>
            }
            saveText="Delete"
            saveBtnClassName="bg-red-500 text-white hover:bg-red-500 hover:text-white"
            isLoading={isDeletePending}
            onSave={onDeleteConfirm}
          >
            <p className="text-sm">
              Are you sure you want to delete this Vendor -{" "}
              <b className="text-primary">{deletedRow?.vendorName || ""}</b>?
            </p>
          </Dialog>
        </>
      )}
    </div>
  );
};

export default VendorMgmt;
